import React from 'react';

const TotalStayCost = ({
    totalAmount,
    currencySymbol = "$",
    rooms = 1,
    nights = 1,
    style = {},
    className = "",
    showRoomNightCount = true
}) => {
    const formatAmount = (amount) => {
        // Handle string inputs with commas (e.g., "2,618.83")
        let numericAmount = amount;
        if (typeof amount === 'string') {
            // Remove commas and convert to number
            numericAmount = parseFloat(amount.replace(/,/g, ''));
        }

        if (typeof numericAmount !== 'number' || isNaN(numericAmount)) {
            return '0.00';
        }
        return numericAmount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    const defaultStyle = {
        font: "11px/14px Futura Lt BT",
        color: "#0D3A7D",
        marginTop: 2,
        paddingBottom: 8,
        ...style
    };

    return (
        <div className={className} style={defaultStyle}>
            Total Stay Cost: <strong style={{ font: "12px/14px Futura Md BT", }}>{currencySymbol}{formatAmount(totalAmount)}</strong>
            {showRoomNightCount && (
                <span> ({rooms}{Number(rooms) === 1 ? 'rm' : 'rms'}/{nights}{Number(nights) === 1 ? 'nt' : 'nts'})</span>
            )}
        </div>
    );
};

export default TotalStayCost;
